export const moduleDashboard = {
	state() {
		return {
			displayFormFastPayment: true,
			displayFormPayout: false,
			displayFormAccounts: false,
			currentAmmount: '',
			disabledPaymentButton: true,
		};
	},
	mutations: {
		setDisplayFormFastPayment(state, data) {
			state.displayFormFastPayment = data;
		},
		setDisplayFormPayout(state, data) {
			state.displayFormPayout = data;
		},
		setDisplayFormAccounts(state, data) {
			state.displayFormAccounts = data;
		},
		setCurrentAmmount(state, value) {
			state.currentAmmount = value;
		},
		setDisabledPaymentButton(state, value) {
			state.disabledPaymentButton = value;
		},
	},
	getters: {
		getDisplayFormFastPayment: (state) => state.displayFormFastPayment,
		getDisplayFormPayout: (state) => state.displayFormPayout,
		getDisplayFormAccounts: (state) => state.displayFormAccounts,
		getCurrentAmmount: (state) => state.currentAmmount,
		getDisabledPaymentButton: (state) => state.disabledPaymentButton,
	},
};
